// extracted by mini-css-extract-plugin
export default {"container":"styles_container__5svfe","backToBenefitsMobile":"styles_backToBenefitsMobile__AUZgs","separator":"styles_separator__bos5T"};